import {
    getPromotionList,
    getRebateData,
} from "../../actions/promotionRequest";
import { promotionActions } from "../promotionSlice";

export function getPromotionListAction() {
    return async function getPromotionListThunk(dispatch, getState) {
        try {
            dispatch(promotionActions.setLoading(true));

            const promotions = await getPromotionList();
            console.log(
                "thunk promotions ===============================> ",
                promotions
            );

            dispatch(promotionActions.setPromotions(promotions));
        } catch (e) {
            console.error(e.message);
        } finally {
            dispatch(promotionActions.setLoading(false));
        }
    };
}

export function getRebateListAction(
    startDate,
    endDate,
    selectedCategory = "All",
    stopLoading
) {
    console.log("thunk11", stopLoading);
    return async function getRebateListThunk(dispatch, getState) {
        try {
            const rebateList = await getRebateData(startDate, endDate);

            if (!rebateList) {
                dispatch(promotionActions.setRebateData({ data: [] }));
                return;
            }
            dispatch(
                promotionActions.setRebateData({
                    data: rebateList.filter((item) => !!item.promotionCategory),
                    selectedCategory,
                })
            );
        } catch (e) {
            console.error("thunk getRebateList error", e.message);
        } finally {
            stopLoading && stopLoading();
        }
    };
}
// export function getRebateListAction(
//   startDate,
//   endDate,
//   selectedCategory = "All",
//   stopLoading
// ) {
//   console.log("thunk11", stopLoading);
//   return async function getRebateListThunk(dispatch, getState) {
//     try {
//       const rebateList = await getRebateData(startDate, endDate);
//       console.log("thunk rebate ===============> ", rebateList);
//       if (!rebateList) {
//         dispatch(promotionActions.setRebateData({ data: [] }));
//         return;
//       }
//       dispatch(
//         promotionActions.setRebateData({ data: rebateList.filter(item=>!!item.promotionCategory), selectedCategory })
//       );
//     } catch (e) {
//       console.error("thunk getRebateList error", e.message);
//     } finally {
//       stopLoading && stopLoading();
//     }
//   };
// }

// export function getAllPromotionRelatedDataAction() {
//     return async function getAllPromotionRelatedDataThunk(dispatch, getState) {
//         dispatch(getPromotionListAction());
//         if (localStorage.getItem("access_token")) {
//             dispatch(getRebateListAction());
//         }
//     };
// }
